import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/pied-piper': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M32 419L0 479.2 0.8 151.2C0.8 85.3 54 32 120 32H447.2C354.2 60.9 257.3 126.2 193.3 200.6 122.7 282 82.6 338 32 419M448 32S305.2 98.8 261.6 199.1C238.4 252.7 232.7 317.2 190.6 357.7 161.7 385.5 120.8 395.9 85.3 414 62.1 426 18.9 454.5 0.4 480H328.8C394.8 480 448.1 426.7 448.1 360.8 448 360.8 448 32 448 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/pied-piper.js
// module id = dbzQ
// module chunks = 144